{
  "title": "如何查看單一作品的評分",
  "description": "查看某件作品目前所有評審給出的分數與審查意見。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您可以看到某件作品目前每位評審的評分狀態、總分與審查意見。",
  "roleNote": "主辦方管理員／工作人員（具評分查看權限 score.read）",
  "prerequisites": ["已具備評分查看權限（score.read）"],
  "pathLabel": "主辦方主控台 → 作品管理 → 作品詳情",
  "steps": [
    {
      "title": "1. 開啟作品詳情",
      "description": "在作品管理清單中點選要查看的作品，進入該作品的詳情頁。"
    },
    {
      "title": "2. 查看評分清單",
      "description": "詳情頁會列出目前所有已指派評審對該作品的評分紀錄，包含評審姓名、評分狀態（未開始／草稿／已鎖定）、總分與審查意見；依更新時間新到舊排序。"
    },
    {
      "title": "3. 判斷是否需要介入",
      "description": "若發現分數異常、審查意見有疑慮，或需要處理評分爭議／利益衝突查核，可依此頁面資訊決定是否需要「重新開啟」該筆分數請評審修改。"
    }
  ],
  "afterward": [
    "可清楚掌握單一作品的完整評分狀況",
    "此頁面不包含評審填寫給自己看的私人評分備註，只顯示提供給主辦方查看的審查意見"
  ],
  "nextSteps": "若需要讓評審修改已送出的分數，請見既有「重新開啟評分」相關操作；若已完成所有作品的評分，請見「如何計算、鎖定並公布結果」。",
  "faq": [
    {
      "q": "這個頁面可以看到評審私下寫給自己的備註嗎？",
      "a": "不行。此頁面刻意只顯示「審查意見」（提供給主辦方查看的欄位），評審自己的私人評分備註不會出現在這裡，確保評審的私人筆記不會被主辦方看到。"
    },
    {
      "q": "評分查看權限跟評分管理權限是同一個嗎？",
      "a": "不是。查看評分內容（score.read）與管理評分相關操作（例如重新開啟）是分開的兩個獨立權限，具查看權限不代表具備管理權限，反之亦然。"
    },
    {
      "q": "可以一次查看整場競賽所有作品的審查意見嗎？",
      "a": "可以。「結果審查」頁每一列都有「查看評審的審查意見」展開區（另有「展開全部審查意見」開關）；若要整場競賽一次取得，請到「匯出中心」下載「評分與審查意見」報表（每位評審對每件作品一列，不含評審私人備註）。"
    }
  ]
}
